$(document).ready(function() {

  if ($(window).width() < 750) {
    $(".control-mobile").click(function(){
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).next('.content-mobile').slideUp(500);
      }
      else {
        $(this).addClass('active');
        $(this).next('.content-mobile').slideDown(500);
      }
    });
  }

  // expand content
  $(".control-expand").click(function(){
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $(this).next('.expand-content').slideUp(500);
    }
    else {
      $(this).addClass('active');
      $(this).next('.expand-content').slideDown(500);
    }
  });
  // end expand content

  // scroll to top button
  $(window).scroll(function() {
    if ($(window).scrollTop() > 100) {
      $('.footer-button-scroll-top').css({"opacity": "1", "visibility": "visible"});
    }
    else {
      $('.footer-button-scroll-top').css({"opacity": "0", "visibility": "hidden"});
    }
  })

  $(".footer-button-scroll-top, .button-scroll-top").click(function(){
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  });
  // end scroll to top button

  // scroll to element
  $('a[href^="#"]').on('click', function (e) {
    e.preventDefault();

    var target = $($(this).attr('href'));

    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top
      }, 600);
    }
  });

  // end scroll to element

});